<div class="results-dialog">
  <button mat-stroked-button color="primary" class="go-back" (click)="goBack()">
    <mat-icon>arrow_back</mat-icon> GO BACK
  </button>

  <h2 class="results-title">
    <mat-icon aria-hidden="true">list</mat-icon>
    Search results for <span class="query-chip">{{ data.query }}</span>
  </h2>
  <p class="results-subtitle">Select a user to show the returns</p>

  <div class="results-scroll">
  <table mat-table [dataSource]="dataSource" class="results-table">
    <ng-container matColumnDef="select">
      <th mat-header-cell *matHeaderCellDef></th>
      <td mat-cell *matCellDef="let row">
        <mat-radio-button
          [checked]="selected?.id === row.id"
          (change)="selected = row"
          [attr.aria-label]="'Select ' + row.fullName">
        </mat-radio-button>
      </td>
    </ng-container>

    <ng-container matColumnDef="id">
      <th mat-header-cell *matHeaderCellDef>Customer ID</th>
      <td mat-cell *matCellDef="let row">{{ row.id }}</td>
    </ng-container>

    <ng-container matColumnDef="fullName">
      <th mat-header-cell *matHeaderCellDef>Customer full name</th>
      <td mat-cell *matCellDef="let row">{{ row.fullName }}</td>
    </ng-container>

    <ng-container matColumnDef="email">
      <th mat-header-cell *matHeaderCellDef>Email</th>
      <td mat-cell *matCellDef="let row">{{ row.email || '—' }}</td>
    </ng-container>

    <ng-container matColumnDef="accountType">
      <th mat-header-cell *matHeaderCellDef>Account type</th>
      <td mat-cell *matCellDef="let row">
        @if (row.enrollmentType) {
          <app-enrollment-type-indicator [enrollmentType]="row.enrollmentType"></app-enrollment-type-indicator>
        } @else {
          —
        }
      </td>
    </ng-container>

    <ng-container matColumnDef="properties">
      <th mat-header-cell *matHeaderCellDef class="num-col">Properties registered</th>
      <td mat-cell *matCellDef="let row" class="num-col">{{ row.propertyCount }}</td>
    </ng-container>

    <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
    <tr mat-row *matRowDef="let row; columns: displayedColumns"
        class="result-row"
        [class.result-row--selected]="selected?.id === row.id"
        (click)="selected = row"></tr>
  </table>
  </div>

  <mat-paginator [pageSize]="10" [pageSizeOptions]="[5, 10, 25]"></mat-paginator>

  <div class="results-actions">
    <button mat-flat-button color="primary" class="view-returns"
            [disabled]="!selected" (click)="viewReturns()">
      <mat-icon>receipt_long</mat-icon> VIEW RETURNS
    </button>
  </div>
</div>
